<template>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Categoria:</strong></label>
            <p>{{ dado.categoria }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Descrição:</strong></label>
            <p>{{ dado.descricao }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Profissional:</strong></label>
            <p>{{ dado.profissional }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Construção:</strong></label>
            <p>{{ dado.construcao_exibicao }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Construção Etapa:</strong></label>
            <p>{{ dado.construcao_etapa }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Unidade de Medida:</strong></label>
            <p>{{ dado.unidade_medida }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Qtd:</strong></label>
            <p class="text-center">{{ dado.quantidade }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Data Início:</strong></label>
            <p>{{ dado.data_inicio }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Data Final Prevista:</strong></label>
            <p>{{ dado.data_prevista_fim }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Data Final:</strong></label>
            <p>{{ dado.data_fim }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Valor Unitário:</strong></label>
            <p class="text-center">{{ dado.valor_unitario }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Valor Total:</strong></label>
            <p class="text-center">{{ dado.valor_total }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label><strong>Observação:</strong></label>
            <p>{{ dado.observacao }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Status Financeiro:</strong></label>
            <p v-html="dado.status_financeiro"></p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Status Execução:</strong></label>
            <p v-html="dado.status_execucao"></p>
          </div>
        </div>
      </div>
      <hr>
      <button class="btn btn-success font-bold" @click="$emit('fechar')">
        Fechar
      </button>
</template>

<script>
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "InformacoesServico",
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.servicos.retrieveUpdateDestroy(this.itemKey)}?modo=info`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
